import { useQuery } from "@tanstack/react-query";
import { getTopper } from "../Service/Api";
import LazyLoad from "react-lazyload";
import Slider from "react-slick";
const TopperX = () => {
  // ✅ Fetch data using React Query
  const {
    data: topperData = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["topperData"],
    queryFn: getTopper,
  });

  // ✅ Handle loading / error (you can style as needed)
  if (isLoading) return <p className="text-center my-5">Loading...</p>;
  if (isError)
    return (
      <p className="text-center text-danger my-5">
        Error fetching topper data: {error.message}
      </p>
    );

  // ✅ Sort data like before
  const sortedData = [...topperData].sort(
    (a, b) => parseFloat(b.division) - parseFloat(a.division),
  );

  // ✅ Dummy fallback if no data
  const emptyArray = [
    {
      name: "Student Name",
      stream: "Subject",
      division: "--%",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/trophy.jpg",
    },

    {
      name: "Student Name",
      stream: "Subject",
      division: "--%",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/trophy.jpg",
    },
    {
      name: "Student Name",
      stream: "Subject",
      division: "--%",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/trophy.jpg",
    },
    {
      name: "Student Name",
      stream: "Subject",
      division: "--%",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/trophy.jpg",
    },
  ];

  // ✅ Slick slider settings (unchanged)
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 4,
    initialSlide: 0,
    slidesToShow: 4,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <Slider {...settings}>
        {sortedData.filter((item) => item.class === "X").length > 0
          ? sortedData
            .filter((item) => item.class === "X")
            .map((item, index) => (
              <div className="item" key={index}>
                <div className="topperdiv">
                  <div className="toppertaj">
                    <LazyLoad
                      offset={10}
                      placeholder={
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/trophy.jpg"
                          alt="Loading..."
                          className="img-fluid"
                        />
                      }
                    >
                      <img
                        src={
                          item.attachments && item.attachments[0]
                            ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                            : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/trophy.jpg"
                        }
                        className="img-fluid"
                        alt={item.name}
                      />
                    </LazyLoad>
                  </div>
                  <div className="topperdesc">
                    <p className="name">{item.name}</p>
                    <p className="per">{item.stream}</p>
                    {/* <p className="stream">{item.division}</p> */}
                  </div>
                </div>
              </div>
            ))
          : emptyArray.map((data, index) => (
            <div className="item" key={index}>
              <div className="topperdiv">
                <div className="toppertaj">
                  <img
                    src={data.attachments}
                    className="img-fluid"
                    alt="Frank Anthony Bangalore"
                  />
                </div>
                <div className="topperdesc">
                  <p className="name">{data.name}</p>
                  <p className="per">{data.division}</p>
                  <p className="stream">{data.stream}</p>
                </div>
              </div>
            </div>
          ))}
      </Slider>
    </>
  );
};

export default TopperX;
